var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckCircleNotFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "check-circle (5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.34 8.08915L9.16738 13.2618L6.07812 10.1725L7.25663 8.994L9.16738 10.9048L13.1615 6.91064L14.34 8.08915Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3327 9.99984C18.3327 14.6022 14.6017 18.3332 9.99935 18.3332C5.39697 18.3332 1.66602 14.6022 1.66602 9.99984C1.66602 5.39746 5.39697 1.6665 9.99935 1.6665C14.6017 1.6665 18.3327 5.39746 18.3327 9.99984ZM16.666 9.99984C16.666 13.6818 13.6813 16.6665 9.99935 16.6665C6.31745 16.6665 3.33268 13.6818 3.33268 9.99984C3.33268 6.31794 6.31745 3.33317 9.99935 3.33317C13.6813 3.33317 16.666 6.31794 16.666 9.99984Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircleNotFilled);
export default __webpack_public_path__ + "static/media/checkCircleNotFilled.04541391d08331972ca4de8c61e9f4b8.svg";
export { ForwardRef as ReactComponent };